module.exports = __webpack_public_path__ + "static/media/main-vt.fa4030b2.png";